import { render, staticRenderFns } from "./SmartTable.vue?vue&type=template&id=6478ff33"
import script from "./SmartTable.vue?vue&type=script&lang=js"
export * from "./SmartTable.vue?vue&type=script&lang=js"
import style0 from "./SmartTable.vue?vue&type=style&index=0&id=6478ff33&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports